
export default {
  name: 'PageHowItWorks',

  head() {
    return {
      title: 'How it works',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: 'Follow these simple steps to bookexclusive use of our dog walking paddocks'
        }
      ]
    }
  },

  computed: {
    compHero() {
      return {
        title: 'How it works',
        image: require('~/assets/images/backgrounds/how-it-works-hero.jpg'),
        alt: 'Dog in Paw Paddock'
      }
    }
  }
}
